
import React,{useEffect,useState} from 'react';
import Aux from '../../../hoc/Auxiliary';
import  "./pagesLinks.css";

const  PagesLinks=(props)=>{
    const [filteredItems,setFilteredItems] = useState([]);
    const [inSearch,setInSearch] = useState(props.inSearch);
    const [input,setInput] = useState('');
    
    const [isEnglish,setIsEnglish] = useState(false);
    const [isArab,setIsArab] = useState(false);

    useEffect(()=>{
        let query = window.location.search;
        let g = query.substring(query.indexOf('k=') + 2);
        setInput(decodeURIComponent(g));
        let tempIsEnglish = document.URL.indexOf("/en/")>0;
        setIsEnglish(tempIsEnglish);

        let tempIsAr = document.URL.indexOf("/ar/")>0;
        setIsArab(tempIsAr);
    },[]);
    useEffect(()=>{
        if(!!props.inSearch){
            setInSearch(props.inSearch);
        }
    },[props.inSearch]);
    useEffect(()=>{
        if(props.items.length>0){
        let tempFilteredItems;
   
         if (inSearch == "searchresults") {
         
            
            tempFilteredItems = props.items
                .filter(item => {
                    return (
                        Boolean(item.floatingText && item.floatingText.includes(this.state.input.trim())) ||
                        Boolean(item.Title && item.Title.includes(this.state.input.trim())) ||
                        Boolean(item.AdditionalRichPageContent && item.AdditionalRichPageContent.includes(this.state.input.trim())) ||
                        Boolean(item.RichPageContent && item.RichPageContent.includes(this.state.input.trim()))
                    )
                })
            }
            else{
                tempFilteredItems = props.items;
            }
            let baseUrl =window.location.origin;
            let pageBaseLink= window.document.baseURI.toLowerCase().split('pages/')[0]+'pages/';
            let items = tempFilteredItems.map((item, index) => {
                let tempImageUrl = !!item.MatalFloatingImage && !!item.MatalFloatingImage.ImageUrl?item.MatalFloatingImage.ImageUrl:''; 
                let itemImg= !!tempImageUrl?  baseUrl+ tempImageUrl:'';
          
                let pageLInk=pageBaseLink+item.LinkFilenameNoMenu;
                let pageCreation= moment(item.PageCreated).format("DD.MM.YY");
                return (
                            <div key={"pagesLinks"+index} className="pagesLinksItem col-12 col-md-5">
                            <a href={pageLInk} className={'link-item'}>
                                <div className={'col-8 col-md-9 text-warper'}>
                                    <div className={'text-date'}>{pageCreation}</div>
                                    <div className={'text-title'}>
                                {/* {item.Title != null ? <span > {item.Title}</span> : <span> {item.floatingText}</span>} */}
                                {item.Title != null ? item.Title :  item.floatingText}
                                </div>
                                </div>
                                <div className={'col-4 col-md-3 img-page-link'}
                                style={{backgroundImage:`url(${itemImg})`}} >
                                </div>
                                </a>
        
                            </div>            
                        )
                    });
                    setFilteredItems(items);
                }  
        }
        ,[props.items])  ;          
    return (
    
            <div className="PagesLinksCont wp-pagesLink">
                <div className={'wp-title col-12 col-md-12'} >{props.title}</div>   
                <div className={'pagesLinksWarpper col-12 col-md-12'}>
                        {filteredItems}
                </div>
            </div>
        );
    
}

export default PagesLinks; 